import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import { getDayMonthYearFormat } from "@cinch-labs/shared-util";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import cx from "classnames";
import Image from "next/legacy/image";
import Link from "next/link";
import styles from "./article-preview-card.module.css";
export const ArticlePreviewCard = ({ image , date , title , path , featured  })=>{
    const { trackEvent  } = useAnalytics();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Guides - click article card`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "link",
                    label: title,
                    action: EventNames.click
                }
            }
        });
    };
    return /*#__PURE__*/ _jsx("li", {
        className: cx(styles["container"], {
            [styles["featuredContainer"]]: featured
        }),
        "data-testid": "article-preview-card",
        children: /*#__PURE__*/ _jsx(Link, {
            href: path,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/ _jsxs("a", {
                href: "/guides",
                "aria-label": title,
                className: styles["listItem"],
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cx(styles["imageContainer"], {
                            [styles["featuredImageContainer"]]: featured
                        }),
                        children: /*#__PURE__*/ _jsx(Image, {
                            className: styles["image"],
                            alt: (image === null || image === void 0 ? void 0 : image.alt) || "",
                            src: (image === null || image === void 0 ? void 0 : image.filename) || `${process.env["STAGE_NAME"] ?? "local" ? "" : process.env["STAGE_URL"]}/image-coming-soon.svg`,
                            layout: "responsive",
                            width: featured ? 345 : 110,
                            height: featured ? 220 : 70,
                            priority: featured
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: cx(styles["content"], {
                            [styles["featuredContent"]]: featured
                        }),
                        children: [
                            /*#__PURE__*/ _jsx(Heading, {
                                element: "h3",
                                className: styles["title"],
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("time", {
                                dateTime: date,
                                className: styles["date"],
                                children: getDayMonthYearFormat(date)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
